import { ModificationType as u } from "@ancon/wildcat-types";
import f from "../currency/getFormattedCurrency.mjs";
import "../currency/getFormattedCurrencyPostfix.mjs";
function $(t, e) {
  return e ? t - e > 0 ? t - e : 0 : t;
}
function l(t, e, o, r) {
  const n = `${e}x ${t}`, i = $(e, o);
  if (i) {
    const d = `(${i}x ${f(
      r.amount,
      r.currency
    )})`;
    return `${n} ${d}`;
  }
  return n;
}
function x(t) {
  return t.reduce(
    (o, r) => {
      const {
        modification: n,
        name: i,
        freeAmount: d,
        quantity: s,
        cost: m,
        replacementName: p,
        totalCost: c
      } = r;
      switch (n) {
        case u.Remove:
          o.removed.push(i);
          break;
        case u.Replace: {
          const a = `${i} → ${p} (${f(
            c.amount,
            c.currency
          )})`;
          o.replaced.push(a);
          break;
        }
        default: {
          const a = l(
            i,
            s,
            d,
            m
          );
          o.added.push(a);
        }
      }
      return o;
    },
    {
      added: [],
      removed: [],
      replaced: []
    }
  );
}
export {
  x as default
};
